import { useNavigate } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components";

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background via-background_2 to-background p-6">
      <div className="bg-secondary rounded-[32px] shadow-2xl p-8 max-w-lg w-full text-center">
        <div className="flex justify-center mb-4">
          <AlertTriangle className="w-20 h-20 text-background/90" />
        </div>
        <h1 className="text-4xl font-bold text-background/95 mb-2">
          Page Not Found
        </h1>
        <p className="text-background/60 text-lg mb-6 px-6">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Button
          onClick={() => navigate("/")}
          className="w-full py-3 bg-secondary hover:!bg-background/10 text-background font-semibold rounded-lg transition-colors"
        >
          Go Back Home
        </Button>
      </div>
    </div>
  );
};

export default PageNotFound;
